import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Typography, Divider, colors,Button,ButtonGroup } from '@material-ui/core';
import {
  Card,
  Table,
  TableBody,
  TableRow,
  TableCell,
  CardHeader,
  CardContent, 
  TableHead,
  TextField, 
} from '@material-ui/core';
import clsx from 'clsx';  
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import { Page } from 'components'; 
import AuthFetch from 'utils/fetch';
import {pveType, pveUrls} from 'utils/pveUrl'; 

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3, 3, 6, 3)
  },
  codesPage:{
    marginTop: theme.spacing(2)
  },
  divider: {
    backgroundColor: colors.grey[300],
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3)
  },
  markdownContainer: {
    maxWidth: 700
  }
}));

const schema = {
  cnt: {
    numericality: {
      greaterThan: 0,
      onlyInteger: true,
    }
  },
};

const BatchFix = (props) => {
  const { post, className, ...rest } = props;
  const classes = useStyles(); 
  const [func,setFunc] = useState('');
  const [msg, setMsg] = React.useState("操作成功");
  const [open, setOpen] = React.useState(false);
  const onChange = (event) => {
    if (event != null) {
      event.persist && event.persist();
    }
    console.log(event.target.value)
    setFunc(event.target.value)
  };
 
  const handleMsgClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const onClick = () => { 
    console.log(func); 
    if (func == ""){
      return 
    }
  
    AuthFetch(pveUrls.batchFixed.path(func), "", pveUrls.batchFixed.method, pveType).then((rv) => {
     
      if (rv.Status.Code == "1"){
        setMsg("领取成功!");
        setOpen(true);
      }
     
    });
  }

  return (
    <Page
      className={classes.root}
      title="玩家数据修复"
    >
      <Typography
        gutterBottom
        variant="overline"
      >
        执行修复
      </Typography>
      <Typography variant="h3">玩家数据修复</Typography>
      <Divider className={classes.divider} />

      <Card
      className={clsx(classes.codesPage, className)}
    >
      <CardHeader title="激活码"/>
      <CardContent className={classes.content}>
      <Snackbar open={open} autoHideDuration={1000} onClose={handleMsgClose}>
          <Alert onClose={handleMsgClose} severity="success">
          {msg}
          </Alert>
          </Snackbar>
      <Table>
              <TableHead/>
              <TableBody>
                <TableRow>
                <TableCell>      
                   <TextField
          required
          id="function"
          label="执行函数"
          type="text"
          defaultValue="batchfix1"
          onChange={onChange}
        /></TableCell>

         <TableCell>
          <Button variant="contained" color='primary' onClick={onClick}>执行</Button>
         </TableCell>
         
              </TableRow> 
            </TableBody>
          </Table> 
          <br></br> 
      </CardContent>
    </Card>
    </Page>
  );
};

export default BatchFix;
